import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Badge from '../../Badge';
import { ChevronDownIcon } from '../../icons/ChevronDownIcon';
import { SelectItem } from '../SelectItem';
import { dropdownMenuListStyles, dropdownPaperStyles, StyledMessage, StyledSelect, StyledSelectContainer } from './styles';
import { type SelectProps } from './types';
const SelectInput = React.forwardRef<HTMLInputElement, SelectProps>((t0, ref) => {
  const $ = _c(30);
  let children;
  let disabled;
  let helperText;
  let name;
  let onChange;
  let placeholder;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      name,
      value: t1,
      onChange,
      disabled,
      placeholder,
      helperText,
      children,
      fullWidth: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = disabled;
    $[3] = helperText;
    $[4] = name;
    $[5] = onChange;
    $[6] = placeholder;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    children = $[1];
    disabled = $[2];
    helperText = $[3];
    name = $[4];
    onChange = $[5];
    placeholder = $[6];
    props = $[7];
    t1 = $[8];
    t2 = $[9];
  }
  const value = t1 === undefined ? "none" : t1;
  const fullWidth = t2 === undefined ? false : t2;
  let t3;
  if ($[10] !== placeholder) {
    t3 = placeholder != null && placeholder !== "" ? <SelectItem disabled={true} value="none"><span className="select-placeholder">{placeholder}</span></SelectItem> : null;
    $[10] = placeholder;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const placeholderItem = t3;
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      PaperProps: {
        sx: dropdownPaperStyles
      },
      MenuListProps: {
        disablePadding: true,
        sx: dropdownMenuListStyles
      }
    };
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== children || $[14] !== disabled || $[15] !== fullWidth || $[16] !== name || $[17] !== onChange || $[18] !== placeholderItem || $[19] !== props || $[20] !== ref || $[21] !== value) {
    t5 = <StyledSelect {...props} name={name} fullWidth={fullWidth} onChange={onChange} value={value} ref={ref} disabled={disabled} IconComponent={ChevronDownIcon} MenuProps={t4}>{placeholderItem}{children}</StyledSelect>;
    $[13] = children;
    $[14] = disabled;
    $[15] = fullWidth;
    $[16] = name;
    $[17] = onChange;
    $[18] = placeholderItem;
    $[19] = props;
    $[20] = ref;
    $[21] = value;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== helperText || $[24] !== props) {
    t6 = helperText != null && <StyledMessage className="helper-text"><Badge color={props.color !== undefined ? props.color : "info"} /><span>{helperText}</span></StyledMessage>;
    $[23] = helperText;
    $[24] = props;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== fullWidth || $[27] !== t5 || $[28] !== t6) {
    t7 = <StyledSelectContainer fullWidth={fullWidth}>{t5}{t6}</StyledSelectContainer>;
    $[26] = fullWidth;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
});
SelectInput.displayName = 'SelectInput';
export default SelectInput;
export { SelectInput };